import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PersonModel } from '@models/person.model';
import { PersonGroupsModel } from '@models/person-groups.model';
import { SaveNewPersonDialogComponent } from '../pages/database/pages/person/dialogs/save-new-person-dialog/save-new-person-dialog.component';
import { EditPersonDialogComponent } from '../pages/database/pages/person/dialogs/edit-person-dialog/edit-person-dialog.component';
import { SaveNewPersonsDialogComponent } from '../pages/database/pages/person/dialogs/save-new-persons-dialog/save-new-persons-dialog.component';
import { ConfirmRecognitionDialogComponent } from '../pages/database/pages/person/dialogs/confirm-recognition-dialog/confirm-recognition-dialog.component';
import { AddPersonToGroupsDialogComponent } from '../pages/database/pages/person/dialogs/add-person-to-groups-dialog/add-person-to-groups-dialog.component';
import { AddPersonByImageDialogComponent } from '../pages/database/pages/person/dialogs/add-person-by-image-dialog/add-person-by-image-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PersonDialogService {
  private readonly dialog = inject(MatDialog);

  public openSavePerson(
    data: PersonModel.UnsavedPerson | PersonModel.SaveNewPersonDialogData,
  ): MatDialogRef<SaveNewPersonDialogComponent> {
    return this.dialog.open(SaveNewPersonDialogComponent, {
      width: '440px',
      panelClass: 'modal-no-padding',
      maxHeight: '600px',
      disableClose: true,
      data,
    });
  }

  public openSavePersons(persons: PersonModel.UnsavedPerson[]): MatDialogRef<SaveNewPersonsDialogComponent> {
    return this.dialog.open(SaveNewPersonsDialogComponent, {
      width: '560px',
      panelClass: 'modal-no-padding',
      height: '70vh',
      maxHeight: '700px',
      disableClose: false,
      data: persons,
    });
  }

  public openEditPerson(
    person: PersonModel.SavedPerson,
    options: { disableClose?: boolean } = {},
  ): MatDialogRef<EditPersonDialogComponent> {
    return this.dialog.open(EditPersonDialogComponent, {
      width: '440px',
      panelClass: 'modal-no-padding',
      maxHeight: '600px',
      disableClose: options.disableClose ?? true,
      data: person,
    });
  }

  public openAddPersonToGroups(
    data: PersonGroupsModel.AddPersonToGroupsDialogData,
  ): MatDialogRef<AddPersonToGroupsDialogComponent, boolean> {
    return this.dialog.open<
      AddPersonToGroupsDialogComponent,
      PersonGroupsModel.AddPersonToGroupsDialogData,
      boolean
    >(AddPersonToGroupsDialogComponent, {
      width: '560px',
      panelClass: 'modal-no-padding',
      disableClose: false,
      data,
    });
  }

  public openAddPersonByImage(): MatDialogRef<AddPersonByImageDialogComponent> {
    return this.dialog.open(AddPersonByImageDialogComponent, {
      width: '440px',
      panelClass: 'modal-no-padding',
      disableClose: true,
    });
  }

  public openConfirmRecognition(
    data: PersonModel.RecognitionDialogData,
  ): MatDialogRef<ConfirmRecognitionDialogComponent, PersonModel.RecognitionDialogResult> {
    return this.dialog.open<
      ConfirmRecognitionDialogComponent,
      PersonModel.RecognitionDialogData,
      PersonModel.RecognitionDialogResult
    >(ConfirmRecognitionDialogComponent, {
      width: '90vw',
      maxWidth: '1000px',
      panelClass: 'modal-no-padding',
      maxHeight: '90vh',
      disableClose: false,
      data,
    });
  }
}
